import { 
    Avatar, Backdrop, Button, Chip, CircularProgress, 
    TableCell, TableRow, Dialog, DialogTitle, 
    DialogContent, DialogActions, TextField, List, ListItem, 
    ListItemAvatar, ListItemText, IconButton, InputAdornment 
} from "@mui/material";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import api from "../../../../../Apis";
import { useTranslation } from "react-i18next";
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';

export default function GroupFanpageItem(props) {
    const { t, i18n } = useTranslation();
    const { stt, data, total_fanpage, fanpages, cookie, index_group } = props;
    
    const [state, setState] = useState({
        fanpageList: [],
        is_loading_page: false
    });

    // Quản lý Dialog và Search
    const [openDialog, setOpenDialog] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        setState(prev => ({ ...prev, fanpageList: fanpages }));
    }, [fanpages]);

    // Lọc danh sách fanpage dựa trên ô search
    const filteredFanpages = state.fanpageList.filter(item => 
        item.fanpage_name.toLowerCase().includes(searchTerm.toLowerCase()) || 
        item.fanpage_id.toString().includes(searchTerm)
    );

    const handleDelete = (fanpage_id, indexInFiltered) => {
        // Tìm index thực tế trong mảng gốc fanpageList
        const realIndex = state.fanpageList.findIndex(item => item.fanpage_id === fanpage_id);

        Swal.fire({
            title: t("groupFanpage.message.confirmRemoveFanpage"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t("common.alert.confirm"),
            cancelButtonText: t("common.alert.cancel")
        }).then((result) => {
            if (result.isConfirmed) {
                setState(prev => ({ ...prev, is_loading_page: true }));
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + cookie
                    },
                    body: JSON.stringify({
                        fanpage_id: fanpage_id,
                        group_id: data.id,
                        lang: i18n.language
                    })
                };
                fetch(api.delete_fanpage_in_group, requestOptions)
                    .then(res => res.json())
                    .then((result) => {
                        if (result.success) {
                            Swal.fire(result.message, "", "success");
                            const fanpageListCopy = [...state.fanpageList];
                            fanpageListCopy.splice(realIndex, 1);
                            setState(prev => ({ 
                                ...prev, 
                                fanpageList: fanpageListCopy, 
                                is_loading_page: false 
                            }));
                        } else {
                            Swal.fire(result.message, "", "warning");
                            setState(prev => ({ ...prev, is_loading_page: false }));
                        }
                    });
            }
        });
    };

    const deleteGroup = (group_id) => {
        Swal.fire({
            title: t("groupFanpage.message.confirmDeleteGroup"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t("common.alert.confirm"),
            cancelButtonText: t("common.alert.cancel")
        }).then((result) => {
            if (result.isConfirmed) {
                setState(prev => ({ ...prev, is_loading_page: true }));
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + cookie
                    },
                    body: JSON.stringify({
                        group_id: group_id,
                        lang: i18n.language
                    })
                };
                fetch(api.delete_group_fanpage, requestOptions)
                    .then(res => res.json())
                    .then((result) => {
                        if (result.success) {
                            Swal.fire(result.message, "", "success");
                            setState(prev => ({ ...prev, is_loading_page: false }));
                            props.updateGroupAfterDelete(index_group);
                        } else {
                            Swal.fire(result.message, "", "warning");
                            setState(prev => ({ ...prev, is_loading_page: false }));
                        }
                    });
            }
        });
    };

    return (
        <>
            {state.is_loading_page && (
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1500 }} open={true}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            )}

            <TableRow>
                <TableCell>{stt}</TableCell>
                <TableCell>{data.name}</TableCell>
                <TableCell>
                    <Button 
                        variant="outlined" 
                        size="small" 
                        onClick={() => setOpenDialog(true)}
                    >
                        {t("Xem danh sách")} ({state.fanpageList.length})
                    </Button>
                </TableCell>
                <TableCell>
                    <Button onClick={() => deleteGroup(data.id)} color="error" variant="contained">
                        {t("groupFanpage.table.deleteGroup")}
                    </Button>
                </TableCell>
            </TableRow>

            {/* Dialog hiển thị danh sách Fanpage */}
            <Dialog 
                open={openDialog} 
                onClose={() => setOpenDialog(false)}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>{t("Danh sách Fanpage trong nhóm")}</DialogTitle>
                <DialogContent dividers>
                    <TextField
                        fullWidth
                        placeholder={t("Tìm kiếm theo tên hoặc ID...")}
                        variant="outlined"
                        size="small"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        sx={{ mb: 2 }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <List sx={{ maxHeight: 400, overflow: 'auto' }}>
                        {filteredFanpages.length > 0 ? (
                            filteredFanpages.map((fanpageItem, index) => (
                                <ListItem
                                    key={fanpageItem.fanpage_id}
                                    secondaryAction={
                                        <IconButton 
                                            edge="end" 
                                            aria-label="delete" 
                                            color="error"
                                            onClick={() => handleDelete(fanpageItem.fanpage_id, index)}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    }
                                >
                                    <ListItemAvatar>
                                        <Avatar src={fanpageItem.avatar} alt={fanpageItem.fanpage_name} />
                                    </ListItemAvatar>
                                    <ListItemText 
                                        primary={fanpageItem.fanpage_name} 
                                        secondary={`ID: ${fanpageItem.fanpage_id}`} 
                                    />
                                </ListItem>
                            ))
                        ) : (
                            <p style={{ textAlign: 'center', color: 'gray' }}>{t("Không tìm thấy fanpage nào")}</p>
                        )}
                    </List>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)} variant="contained">
                        {t("common.alert.cancel")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}